/**
 * The SINGLE sign-out source of truth (docs/05 single sign-out source). One path clears ALL
 * local state - Auth session, TanStack Query cache, zustand stores, persisted acting-center
 * selection, the remember-me flag. Partial sign-outs leak privileged data on shared machines.
 */
import { signOut as fbSignOut } from 'firebase/auth';
import { auth } from '@/lib/backend/firebase';
import { queryClient } from '@/app/query-client';
import { useActingCenterStore } from '@/app/acting-center/acting-center-store';
import { useAuthStore } from './auth-store';
import { clearRememberMe } from './remember-me';

export async function signOutEverywhere(notice?: string | null): Promise<void> {
  try {
    await fbSignOut(auth);
  } finally {
    clearRememberMe();
    queryClient.clear();
    useActingCenterStore.getState().reset();
    useAuthStore.getState().setSignedOut(notice ?? null);
  }
}
